export const getIsPaired = (state: StationStore) => state.role === "camera";

export const getCanRecord = (state: StationStore) => state.recordingMode === "ON";

const selectors = {
  getIsPaired,
  getCanRecord
};

export default selectors;
